import "./style.scss";

const SideBlock = () => {
    return <div className="SideBlock"></div>;
};

export default SideBlock;
